import { Box } from '@chakra-ui/react';

import TableComponent from 'UiKit/table-component';
import { Condition } from 'Component/others';

import { getTableList } from 'View/report-host-tasks/section/table/const';
import { useReportHostTasksState } from 'View/report-host-tasks/state';

import styles from './styles.module.css';

const Table = ({ data, isFetching, t }) => {
  const { filterState, updateFilterState } = useReportHostTasksState();

  const onChangePagination = (page) => updateFilterState({ page });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching}>
        <Box className={styles['table__wrapper']}>
          <TableComponent
            columns={getTableList({ t })}
            dataSource={data?.reports || []}
            isDataExist={data?.isDataExist}
            isScrollable={true}
            tableName="table__report-host-task"
            verticalAlignBody={'baseline'}
            paddingBodyBox={'0px'}
            rowHeight={'fit-content'}
            maxTableHeight="calc(100vh - 253px)"
            maxTableBodyHeight="calc(100vh - 385px)"
            tableComponentHeight="calc(100vh - 240px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

export default Table;
